import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { UserConnectionResponse } from '../../types/Types';

interface useGetConnectionRequestsProps {
  userId: string;
  enabled?: boolean;
}

export function useGetConnectionRequests({ userId, enabled = true }: useGetConnectionRequestsProps) {
  return useQuery({
    enabled,
    queryKey: ['connectionrequests', userId],
    queryFn: async () => {
      return axiosInstance<UserConnectionResponse>(getAPIURL(`/User/connectionrequests/${userId}/`)).then(
        (response) => response.data,
      );
    },
  });
}